export default {
  name: 'language',
  data: function() {
    return {
      lang: ''
    }
  },
  computed: {
    languages: function() {
      return this.$store.getters.languages
    },
    countries: function() {
      return this.$store.getters.countries
    }
  },
  methods: {
    getFlag: function(lang) {
      return '../static/flags/' + lang + '.png'
    },
    goToLanding: function(lang) {
      let id = lang
      this.$router.push({
        name: 'landing',
        params: {
          id
        }
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/language/language.js